/* Posuvný rad vôní — šípky pre myš a klávesnicu.
   Samotné posúvanie je natívny overflow-x so scroll-snapom, takže bez tohto
   súboru rad stále funguje prstom aj kolieskom; JS len dokresľuje šípky.
   Inicializuje každý .rail na stránke — homepage ich má dva (Novinky,
   Bestsellers), detail vône jeden ("Ďalšie odstreky"). */
(function () {
  function init(root) {
    var track = root.querySelector('[data-rail-track]');
    var arrows = root.querySelector('[data-rail-arrows]');
    if (!track || !arrows) return;
    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');

    // O koľko posunúť: šírka karty + medzera. Číta sa z DOM, aby to sedelo aj
    // po zmene breakpointu (karta je na mobile vo vw, na desktope v px).
    function step() {
      var card = track.querySelector('.rail-card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function sync() {
      var overflow = track.scrollWidth - track.clientWidth;
      // Šípky dávajú zmysel len keď je čo posúvať — pri troch vôňach na širokom
      // monitore sa rad zmestí celý a šípky by boli mŕtve tlačidlá.
      arrows.hidden = overflow < 4;
      var x = track.scrollLeft;
      prev.disabled = x < 4;
      next.disabled = x > overflow - 4;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  }

  document.querySelectorAll('.rail').forEach(init);
})();
